import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AnalyticsModule } from './analytics/analytics.module';
import { ApiModule } from './api/api.module';
import { ApplicationBridgeModule } from './application-bridge/application-bridge.module';
import { ApplicationConfigModule } from './application-config/application-config.module';
import { ClientConfigurationModule } from './client-configuration/client-configuration.module';
import { EnvironmentModule } from './environment/environment.module';
import { GatewaySessionTokenModule } from './gateway-session-token/gateway-session-token.module';
import { InjectionTokenModule } from './injection-token/injection-token.module';
import { LocaleModule } from './locale/locale.module';
import { NotificationModule } from './notification/notification.module';
import { PageSpinnerModule } from './page-spinner/page-spinner.module';
import { ParentConfigModule } from './parent-config/parent-config.module';
import { PaymentConfigurationModule } from './payment-configuration/payment-configuration.module';
import { RoutingModule } from './routing/routing.module';
import { SessionModule } from './session/session.module';
import { StaticDataModule } from './static-data/static-data.module';

@NgModule({
  declarations: [],
  imports: [
    InjectionTokenModule,
    AnalyticsModule,
    ApiModule,
    ApplicationConfigModule,
    ClientConfigurationModule,
    CommonModule,
    EnvironmentModule,
    StaticDataModule,
    LocaleModule,
    PaymentConfigurationModule,
    PageSpinnerModule,
    RoutingModule,
    SessionModule,
    GatewaySessionTokenModule,
    ApplicationBridgeModule,
    ParentConfigModule,
    NotificationModule,
  ],
})
export class CoreModule {}
